export enum WorkflowActionIds {
    APPROVE = 0,
    REJECT = 1
}